import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DIFFICULTIES } from "../../../constants";
import { setDifficulties } from "../../../store/actions";
import { Button } from "../../shared";
import styles from "./GameModeDifficulty.module.scss";

const GameModeDifficulty: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (e: any) => {
    const difficulty = e.target.dataset.attribute;
    dispatch(setDifficulties(+difficulty));
    navigate("/play");
  };

  return (
    <div className={styles.difficulty}>
      <h2 className={styles.difficulty__title}>Choose difficulty</h2>
      <div className={styles.difficulty__options}>
        <div className={styles.difficulty__options__easy}>
          <div className={styles.difficulty__options__easy__overlay}></div>

          <Button
            type="button"
            className={styles.difficulty__options__easy__btn}
            onClick={handleClick}
            dataAttribute={DIFFICULTIES.EASY}
          >
            Easy
          </Button>
        </div>

        <div className={styles.difficulty__options__medium}>
          <div className={styles.difficulty__options__medium__overlay}></div>

          <Button
            type="button"
            className={styles.difficulty__options__medium__btn}
            dataAttribute={DIFFICULTIES.MEDIUM}
            onClick={handleClick}
          >
            Medium
          </Button>
        </div>

        <div className={styles.difficulty__options__intermediate}>
          <div
            className={styles.difficulty__options__intermediate__overlay}
          ></div>

          <Button
            type="button"
            className={styles.difficulty__options__intermediate__btn}
            dataAttribute={DIFFICULTIES.INTERMEDIATE}
            onClick={handleClick}
          >
            Intermediate
          </Button>
        </div>

        <div className={styles.difficulty__options__hard}>
          <div className={styles.difficulty__options__hard__overlay}></div>
          <Button
            type="button"
            className={styles.difficulty__options__hard__btn}
            onClick={handleClick}
            dataAttribute={DIFFICULTIES.HARD}
          >
            Hard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GameModeDifficulty;
